import { __decorate } from "tslib";
import $ from 'jquery';
import { enterTransition, leaveTransition } from '../utils/transition';
import { throttle } from 'helpful-decorators';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import { Breakpoint } from '../types/breakpoint';
export default class SubNavbar {
    static $backdrop = $('.js__sub-navbar-backdrop');
    static $subNavbarCollapse = $('.js__sub-navbar-collapse');
    static $subNavbarOpen = $('.js__sub-navbar-open');
    static init() {
        this.bindEvents();
    }
    static openNavbar() {
        this.$subNavbarOpen.addClass('active');
        this.$subNavbarCollapse.addClass('show');
        this.showBackdrop();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                enterTransition(this.$subNavbarCollapse, this.$subNavbarCollapse);
            });
        });
    }
    static async closeNavbar(transition = true) {
        await leaveTransition(this.$subNavbarCollapse, this.$subNavbarCollapse, transition);
        this.$subNavbarCollapse.removeClass('show');
        await this.hideBackdrop();
        this.$subNavbarOpen.removeClass('active');
    }
    static bindEvents() {
        $('.js__sub-navbar-link-toggle').on('click', event => {
            this.closeNavbar();
        });
        this.$subNavbarOpen.on('click', () => {
            if (!this.$subNavbarCollapse.hasClass('show')) {
                this.openNavbar();
            }
            else {
                this.closeNavbar();
            }
        });
        this.$backdrop.on('click', () => {
            this.closeNavbar();
        });
        $(window).on('resize', this.handleResize.bind(this));
    }
    static handleResize() {
        if (!this.isDesktopNavbar() || !this.$subNavbarCollapse.hasClass('show')) {
            return;
        }
        this.closeNavbar(false);
    }
    static showBackdrop() {
        this.$backdrop.addClass('show');
        $(document.body).addClass('sub-navbar-open');
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                enterTransition(this.$backdrop);
            });
        });
    }
    static async hideBackdrop() {
        await leaveTransition(this.$backdrop);
        this.$backdrop.removeClass('show');
        $(document.body).removeClass('sub-navbar-open');
    }
    static isDesktopNavbar() {
        return getCurrentBreakpoint() === Breakpoint.xl;
    }
}
__decorate([
    throttle(300)
], SubNavbar, "handleResize", null);
